import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
// import MenuIcon from '@material-ui/icons/Menu';
import LinkIcon from '@material-ui/icons/Link';
// import SettingsIcon from '@material-ui/icons/Settings';

// import Settings from '../settings';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		'& svg': {
			color: 'white',
		},
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},

	menuStyle: {
		background: 'transparent',
		boxShadow: 'none',
	},
}));

const Index = () => {
	const classes = useStyles();

	// const [subtitleField, setSubtitleField] = useState(false);
	// const [descriptionField, setDescriptionField] = useState(false);

	return (
		<div className={classes.root}>
			<AppBar className={classes.menuStyle} position='static'>
				<Toolbar>
					<IconButton
						edge='start'
						className={classes.menuButton}
						color='inherit'
						aria-label='menu'
						disabled
					>
						<LinkIcon />
					</IconButton>
					<Typography variant='h6' className={classes.title}>
						LINK SAVER
					</Typography>
					{/* <IconButton
						edge='start'
						className={classes.menuButton}
						color='inherit'
						aria-label='menu'
					>
						<SettingsIcon />
					</IconButton> */}
				</Toolbar>
			</AppBar>
		</div>
	);
};

export default Index;
